import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerInfoLoadIfNormalUserGuard } from 'app/core/guards/customer-info-load-if-normal-user.guard';
import { DependencyTreeGuard } from 'app/core/guards/dependency-tree.guard';
import { GetDefinitionsGuard } from '../../core/store/definitions/definitions.resolve';
import { CreateFlowGuard } from '../../core/store/edit-flow-detail/flow-detail-create.resolve';
import { EditFlowGuard } from '../../core/store/edit-flow-detail/flow-detail-edit.resolve';
import { GetFlowGuard } from '../../core/store/edit-flow-detail/flow-detail.resolve';
import { FlowEditContainer } from '../flow/flow-edit-container/flow-edit.container';
import { DisputeFlowGuard } from '../../core/store/edit-flow-detail/flow-detail-dispute.resolve';

const routes: Routes = [
  {
    path: 'flows/new',
    component: FlowEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [CreateFlowGuard],
    },
  },
  {
    path: 'flows/copy',
    component: FlowEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [CustomerInfoLoadIfNormalUserGuard, GetDefinitionsGuard],
    },
  },
  {
    path: 'flows/:etmOrderNumber',
    component: FlowEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [GetFlowGuard],
    },
  },
  {
    path: 'flows/:etmOrderNumber/edit',
    component: FlowEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [EditFlowGuard],
      accept: false,
    },
  },
  {
    path: 'flows/:etmOrderNumber/dispute',
    component: FlowEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [DisputeFlowGuard],
      accept: false,
    },
  },
  {
    path: 'flows/:etmOrderNumber/accept',
    component: FlowEditContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [EditFlowGuard],
      accept: true,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FlowRoutingModule {}
